module.exports = "/_next/static/images/cv-ketel-f178f22ed8d7ef252a33128deba6407e.jpg";